import axios from 'axios';

const myBaseURL = (isProductVersion = false) => {
    if (isProductVersion) {
        return 'https://bulldozer.bybieyang.com';
    }
    return 'https://bulldozer.bybieyang.com'
}

class Bulldozer {
    constructor() {
        this.baseURL = myBaseURL(process.env.REACT_APP_SERVER_ENV === 'production');
        this.bulldozer = axios.create({
            baseURL: this.baseURL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'X-BieYang-Access-Key': '01h2tmr9LxCr9q93HfdahDDjUOrv2dKy',
                'User-Agent': 'Curator'
            }
        });
    }

    get(path = '', param) {
        if (param != {}) {
            return this
                .bulldozer
                .get(path, {
                    params: param
                });
        } else {
            return this
                .bulldozer
                .get(path);
        }
    }

    post(path = '', param) {
        return this
            .bulldozer
            .post(path, param);
    }

    patch(path = '', param) {
        return this
            .bulldozer
            .patch(path, param);
    }

    put(path = '', param) {
        return this
            .bulldozer
            .put(path, param);
    }

    upload(path = '', param) {
        return this
            .bulldozer
            .post(path, param, {
                headers: {
                    ...this.fetcher.headers,
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
}

const bulldozer = new Bulldozer();
export default bulldozer;